import BaseService from './base.service';

/**
 * Manager-facing wrapper around the unified invite collection.
 *
 * Endpoints:
 *   GET    /orgs/:orgId/properties/:propertyId/invites?status=...
 *   POST   /orgs/:orgId/properties/:propertyId/registrations/:inviteId/approve
 *   DELETE /orgs/:orgId/properties/:propertyId/invites/:inviteId
 *
 * Approve hits the `/registrations/:inviteId/approve` route — SD-2928 collapsed
 * the legacy registration-approval route and the unified invite-approval route
 * into one endpoint. The path keeps the `registrations` segment for backwards
 * compatibility with older clients; the `:inviteId` param is the unified
 * invite ID and is passed straight into `PropertyService.approveInvite`.
 */
export default class InvitesService {
    static ENDPOINT = '/orgs';

    static async getPropertyInvites(orgId, propertyId, statuses = []) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/invites`;
        const params = {};
        if (statuses && statuses.length) {
            params.status = Array.isArray(statuses) ? statuses.join(',') : statuses;
        }
        return BaseService.get(endpoint, params);
    }

    static async approveInvite(orgId, propertyId, inviteId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/registrations/${inviteId}/approve`;
        return BaseService.post(endpoint, null);
    }

    static async deleteInvite(orgId, propertyId, inviteId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/properties/${propertyId}/invites/${inviteId}`;
        return BaseService.delete(endpoint);
    }

    /**
     * Public (unauthenticated) email-link decline. Soft-deletes the invite
     * (→ `deleted`) via the same service as the admin delete; the dedicated
     * `@Public()` route exists only because the admin delete is permission-
     * guarded. Bearer-by-id: the unguessable inviteId authorizes the action.
     */
    static async decline(inviteId) {
        return BaseService.delete(`/invites/${inviteId}/decline`);
    }
}
